import React from 'react';
import ToolkitSvgSprite from '../../images/vector/lantern-sprite.svg';

const SvgSprite = () => (
    <div className="svg-sprite-container">
        <ToolkitSvgSprite />
    </div>
);

export default SvgSprite;
